import { z } from 'zod';
import { TFunction } from 'i18next';

export const createPasswordSchema = (t: TFunction) =>
  z
    .object({
      oldPassword: z.string().min(1, t('validity.valueMissing.defaultMessage')),
      newPassword: z
        .string()
        .min(8, t('validation.password.minLength'))
        .regex(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,}$/, t('validation.password.complexity')),
      retypePassword: z.string().min(1, t('validity.valueMissing.defaultMessage'))
    })
    .refine((data) => data.newPassword === data.retypePassword, {
      message: t('pref.passwordmatch.message'),
      path: ['retypePassword']
    });

export type PasswordFormValues = z.infer<ReturnType<typeof createPasswordSchema>>;
